import { gql } from 'graphql-tag';

export const GET_MYSTAGE_LESSON_TOKEN = gql`
  query mystageLesson($student_book_id: Int!) {
    mystage_lesson(student_book_id: $student_book_id) {
      token
    }
  }
`;

export const GET_MYSTAGE_LESSON_TOKEN_MSB = gql`
  query myStageLesson($student_book_id: Int!) {
    myStageLesson(student_book_id: $student_book_id, with_uid: true) {
      token,
      socket_token
    }
  }
`;

export const GET_MYSTAGE_ADMIN_TRAINER_LESSON_TOKEN_MSB = gql`
  query mystageAdminTrainerLesson($student_book_id: Int!) {
    myStageTestLesson(student_book_id: $student_book_id) {
      token
    }
  }
`;

export const GET_MYSTAGE_DEV_TEST_LESSON_TOKEN = gql`
  query mystageDevTestLesson($input: DevTestLessonInput!) {
    mystageDevTestLesson(input: $input) {
      token
    }
  }
`;

export const GET_MYSTAGE_AGORA_TOKEN = gql`
  query agoraTokenNew($uid: Int!, $student_book_id: Int!, $is_compute: Boolean!) {
    agoraTokenNew(uid: $uid, student_book_id: $student_book_id, is_compute: $is_compute) {
      agora_token
      uid
    }
  }
`;
